import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'

const CDFUploader = ({ handleFileUpload, handleReset, fileTypesAccepted, loading, droppedFiles, setDroppedFile }) => {
  const [isFileOver, setIsFileOver] = useState()
  const fileInputRef = useRef(null)

  const handleDrop = (e) => {
    e.preventDefault()
    const [file] = e.dataTransfer.files
    setDroppedFile(file)
    setIsFileOver(false)
    if (file) {
      handleFileUpload(file)
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handleClick = (e) => {
    const [file] = e.target.files
    setDroppedFile(file)
    if (file) {
      handleFileUpload(file)
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
    }
  }

  return (
    <div
      className={`file-dropzone d-flex align-items-center justify-content-center pointer p-4 ${isFileOver ? 'bg-light border-dark' : ''}`}
      onDrop={handleDrop}
      onDragOver={(e) => {
        e.preventDefault()
        setIsFileOver(true)
      }}
      onDragLeave={(e) => {
        e.preventDefault()
        setIsFileOver(false)
      }}
      onClick={() => {
        if (fileInputRef.current) {
          fileInputRef.current.click()
        }
      }}
    >
      {droppedFiles
        ? <div
          className='file-icon d-flex flex-column justify-content-center align-items-center position-relative px-3'>
          <div
            className='position-absolute'
            style={{ right: '6px', top: '6px' }}
            onClick={(e) => {
              if (!loading) {
                e.stopPropagation()
                setDroppedFile(false)
                handleReset()
              }
            }}
          >
            <span className={loading ? 'fas fa-cog fa-spin text-success' : 'fas fa-times-circle text-danger'} />
          </div>
          <div className='d-flex align-items-center flex-column justify-content-center'>
            <span className='mb-1 py-1'>{Math.round(droppedFiles?.size / 1024)} KB</span>
            <small className='bg-light rounded text-truncate p-1'>{droppedFiles?.name}</small>
          </div>
        </div>
        : isFileOver
          ? <span>Drop File</span>
          : <span>Drag and drop or <span className='text-primary'>click here</span> to upload</span>
      }
      <input
        type='file'
        accept={fileTypesAccepted}
        ref={fileInputRef}
        className='d-none'
        onChange={handleClick}
      />
    </div>
  )
}

CDFUploader.propTypes = {
  handleFileUpload: PropTypes.func,
  handleReset: PropTypes.func,
  fileTypesAccepted: PropTypes.string,
  loading: PropTypes.bool,
  droppedFiles: PropTypes.any,
  setDroppedFile: PropTypes.func
}

export default CDFUploader
